"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_css_themr_1 = require("react-css-themr");
const IconItem_1 = require("../IconItem");
const List_1 = require("../List");
const DumpIconItemList = ({ data: { items, theme: dataTheme = {} }, theme: defaultTheme = {}, }) => {
    const theme = { ...defaultTheme, ...dataTheme };
    return (React.createElement(List_1.default, { entities: items, theme: theme.list, renderItem: (item) => (React.createElement(IconItem_1.default, { data: item, theme: theme.item })) }));
};
exports.defaultIconItemListTheme = {};
const IconItemList = react_css_themr_1.themr('IconItemList', {}, { composeTheme: 'softly' })(DumpIconItemList);
exports.default = IconItemList;
//# sourceMappingURL=index.js.map